/* eslint-disable max-len */
const benefits = {
  state: {
    step: 'B1',
    status: 'Created',
  },
  providers: {
    health: null,
    dental: null,
    vision: null,
    retirement: null,
    longTermDisability: null,
    shortTermDisability: null,
    groupLife: null,
    supplemental: null,
  },
  currentHealthCarrier: {
    carrierName: null,
    policyEffectiveDate: null,
    insuranceInfoRatesId: null,
    insuranceInfoRates: [
      {
        planNumber: null,
        contributionType: null,
        currentChildRate: null,
        currentEmployeeRate: null,
        currentSpouseRate: null,
        currentFamilyRate: null,
        contributionChildRate: null,
        contributionEmployeeRate: null,
        contributionSpouseRate: null,
        contributionFamilyRate: null,
      },
    ],
  },
  generalInfo: {
    currentEmployeesExceeding10kExplanation: null,
    preExistingChronicConditionExplanation: null,
    maintenanceMedicationsExplanation: null,
    advisedToHaveSurgeryExplanation: null,
    confinedForTreatmentExplanation: null,
    currentPregnanciesExplanation: null,
    chronicMissingDaysExplanation: null,
  },
  cobraElectionPeriod: [
    {
      name: null,
      dob: null,
      activatingEvent: null,
      effectiveDate: null,
      dateOfEvent: null,
      dobMenu: false,
      effectiveDateMenu: false,
      dateOfEventMenu: false,
    },
  ],
  flags: {
    benefitsAlreadyProvided: false,
    employeesOnCobra: false,
    employeesinCobraElectionPeriod: false,
    currentEmployeesExceeding10k: false,
    preExistingChronicCondition: false,
    maintenanceMedications: false,
    advisedToHaveSurgery: false,
    confinedForTreatment: false,
    currentPregnancies: false,
    chronicMissingDays: false,
    disability5Years: false,
  },
  documents: [
    {
      name: null,
      category: null,
    },
  ],
};

export default benefits;
